export default __webpack_public_path__ + "static/media/pk.c6b49a9f.svg";